<template>
  <div style="overflow-x: hidden;">
    <v-row no-gutters style="min-height: 100vh">
      <v-col cols="12" sm="6" style="background-color: #e1edba">
        <v-container bg fill-height class="pa-0 ma-0">
          <v-layout row wrap align-center>
            <v-row>
              <div class="pa-lg-16 pa-9">
                <h1>CONSULTA LA TABLA DE LOS PRECIOS AGRÍCOLAS</h1>
                <p class="subtitle">
                  Aquí puedes consultar la información diaria de todos los cultivos agrícolas.  Con esto, te puedes dar una idea sobre el precio al que debes vender tus productos.
                  <br/><br/>
                  Estamos trabajando en subir más datos para que podamos recomendarte si te conviene vender o comprar hoy mismo o si debieras esperarte algunos días.  
                  <br/><br/>
                  Espera nuestra nueva sección de recomendaciones.

                </p>
                <router-link class="orange--text" to="/preciosCommodities">Ver precios</router-link>
              </div>
            </v-row>
          </v-layout>
        </v-container>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="white--text myBanner"
        :style="{
          'background-image': 'url(' + items[0].src + `)`,
        }"
      ></v-col>
    </v-row>
  </div>
</template>
<style scoped>
.imgDiv {
  margin: 0;
  padding: 0;
}
.myBanner {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
<script>
export default {
  name: "Bienvenido",
  data: () => ({
    items: [
      {
        src: require("../../../assets/HOME-8.png"),
      },
    ],
  }),
};
</script>